import React from 'react';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../BlockContent.utils';

interface CodeProps {
  value: { language: string; code: string };
}

export const CodeTypesBlock = ({ value: { language, code } }: CodeProps) => (
  <pre data-language={language}>
    <code>{code}</code>
  </pre>
);

export const CodeTypesSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: CodeProps) => (
      <ArticleBlockContentGridCol>
        <CodeTypesBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: CodeProps) => <CodeTypesBlock value={value} />;
};
